import { createFileRoute } from '@tanstack/react-router'
import FiveYearsInspectionPage from 'pages/app/five-years-inspection-page/FiveYearsInspectionPage'
import { z } from 'zod'

const fiveYearsInspectionSearchSchema = z.object({
  mode: z.enum(['view', 'edit']).optional().catch(undefined),
})

export const Route = createFileRoute(
  '/_authenticated/app/uppdrag/$uuid/fivey/$fiveyid'
)({
  component: FiveYearsInspectionPage,
  validateSearch: fiveYearsInspectionSearchSchema,
})
